import { render } from "./GoalSubHeader.vue?vue&type=template&id=254fecc4&scoped=true"
import script from "./GoalSubHeader.vue?vue&type=script&lang=js"
export * from "./GoalSubHeader.vue?vue&type=script&lang=js"

import "./GoalSubHeader.vue?vue&type=style&index=0&id=254fecc4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-254fecc4"

export default script